import React, { useEffect } from 'react';
import styled from 'styled-components';
import { createGlobalStyle } from 'styled-components';
const Full = styled.div`
    height: 100%;
    .fullscreen{
        width: 100%;
        height: 100%;
    }
`;

const GlobalStyle = createGlobalStyle`
    body{
        overflow: auto;
    }
    #App{
        height: 100%;
        .body-wrapper{
            height: 100%;
        }
    }
`;

export default  () => {
    return (
        <Full>
            <GlobalStyle />
            <iframe className="fullscreen" src="https://signup.getmati.com/?merchantToken=61660074564076001bed8348&flowId=62334d40e04004001cf39aaa"></iframe>
        </Full>
    );
};


